/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Hours } from './Hours';
import {
    HoursFromJSON,
    HoursFromJSONTyped,
    HoursToJSON,
    HoursToJSONTyped,
} from './Hours';

/**
 * 
 * @export
 * @interface RequestDeliveryHoursChangeRequest
 */
export interface RequestDeliveryHoursChangeRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestDeliveryHoursChangeRequest
     */
    shipmentId: string;
    /**
     * 
     * @type {Hours}
     * @memberof RequestDeliveryHoursChangeRequest
     */
    newDeliveryHours: Hours;
}

/**
 * Check if a given object implements the RequestDeliveryHoursChangeRequest interface.
 */
export function instanceOfRequestDeliveryHoursChangeRequest(value: object): value is RequestDeliveryHoursChangeRequest {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    if (!('newDeliveryHours' in value) || value['newDeliveryHours'] === undefined) return false;
    return true;
}

export function RequestDeliveryHoursChangeRequestFromJSON(json: any): RequestDeliveryHoursChangeRequest {
    return RequestDeliveryHoursChangeRequestFromJSONTyped(json, false);
}

export function RequestDeliveryHoursChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestDeliveryHoursChangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentId': json['shipmentId'],
        'newDeliveryHours': HoursFromJSON(json['newDeliveryHours']),
    };
}

  export function RequestDeliveryHoursChangeRequestToJSON(json: any): RequestDeliveryHoursChangeRequest {
      return RequestDeliveryHoursChangeRequestToJSONTyped(json, false);
  }

  export function RequestDeliveryHoursChangeRequestToJSONTyped(value?: RequestDeliveryHoursChangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentId': value['shipmentId'],
        'newDeliveryHours': HoursToJSON(value['newDeliveryHours']),
    };
}

